import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";

import { FC } from "react";
import ToomanIcon from "@svg/new-design/tooman";

import DiscountBadge from "@shared/components/card/discout-badge";
import { FESTIVAL_TYPE } from "enums/festival-type";

interface Props {
  salePrice: number | undefined;
  price: number | undefined;
  discount: number | undefined;
  isPercentDiscount: boolean | undefined;
  id: number;
  sku?: string;
  inCart: boolean | undefined;
}

const CommonFooterCard: FC<Props> = ({
  salePrice,
  price,
  discount,
  isPercentDiscount,
}) => {
  return (
    <div className="h-10 flex-col gap-y-1.5  items-end  flex justify-end w-full grow ">
      <div className="flex gap-0.5 items-center">
        {salePrice && (
          <s className="text-fds-tertiary body-sm leading-4">
            {separateMoneyNumbers(toFarsiNumber(price))}
          </s>
        )}
        {discount && (
          <DiscountBadge
            className="!h-4    "
            discount={isPercentDiscount ? discount : FESTIVAL_TYPE.WONDER}
          />
        )}
      </div>
      <p className="headline-md flex  text-fds-primary">
        {separateMoneyNumbers(toFarsiNumber(salePrice ? salePrice : price))}
        <ToomanIcon className="mr-0.5 mt-1" />
      </p>
    </div>
  );
};

export default CommonFooterCard;
